import React, { useCallback, useEffect, useState } from 'react';
import Context from './context';
import usePldFinance from '../../hooks/usePldFinance';
import { Bank } from '../../pld-finance';
import config, { bankDefinitions } from '../../config';

const Banks: React.FC = ({ children }) => {
  const [banks, setBanks] = useState<Bank[]>([]);
  const pldFinance = usePldFinance();
  const isUnlocked = pldFinance?.isUnlocked;

  const fetchPools = useCallback(async () => {
    const banks: Bank[] = [];

    for (const bankInfo of Object.values(bankDefinitions)) {
      if (bankInfo.finished) {
        if (!pldFinance.isUnlocked) continue;

        // only show pools staked by user
        const balance = await pldFinance.stakedBalanceOnBank(
          bankInfo.contract,
          bankInfo.poolId,
          pldFinance.myAccount,
        );
        if (balance.lte(0)) {
          continue;
        }
      }
      banks.push({
        ...bankInfo,
        address: config.deployments[bankInfo.contract].address,
        depositToken: pldFinance.externalTokens[bankInfo.depositTokenName],
        earnToken: bankInfo.earnTokenName === 'PLD' ? pldFinance.PLD : pldFinance.pSHARE,
      });
    }
    banks.sort((a, b) => (a.sort > b.sort ? 1 : -1));
    setBanks(banks);
  }, [pldFinance, setBanks]);

  useEffect(() => {
    if (pldFinance) {
      fetchPools().catch((err) => console.error(`Failed to fetch pools: ${err.stack}`));
    }
  }, [isUnlocked, pldFinance, fetchPools]);

  return <Context.Provider value={{ banks }}>{children}</Context.Provider>;
};

export default Banks;
